import React from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import cs from './index.module.scss';
import WarningCircleIcon from '@/components/icons/WarningCircleIcon';
import CloseFilledIcon from '@/components/icons/CloseFilledIcon';
import { useStore } from '@/models';

const Header: React.FC = () => {
  const { notice } = useStore();
  const { isShowNotice, setIsShowNotice, maintain } = notice;

  const closeHandleClick = () => {
    setIsShowNotice(false);
  };

  return (
    <>
      {isShowNotice ? (
        <div className={cx(cs.container)}>
          <WarningCircleIcon className={cs.icon} />
          <div className={cs.content}>
            {maintain?.title || ''} {maintain?.content || ''}
          </div>
          <CloseFilledIcon className={cs.close} onClick={closeHandleClick} />
        </div>
      ) : null}
    </>
  );
};

export default observer(Header);
